import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {putFeedback, useSagaCallback} from "../utils/sagas";
import {apiClient, setApiCredentials} from './client';
import {loadUserProfile} from "./user";

async function getToken() {
    const resp = await apiClient.request({
        method: "POST",
        url: `/api/v2/token`,
        withCredentials: true,
        headers: {}
    });
    const {status, error, api_key, api_secret} = resp.data;
    if (typeof status === 'boolean') {
        // new API status style
        if (status === false) {
            throw new Error(error);
        }
    } else if (status !== 'success') {
        // old API status style
        throw new Error(status);
    }
    return [api_key, api_secret];
}

async function signIn(username, password) {
    const body = new URLSearchParams();
    body.set('username', username);
    body.set('password', password);
    const { data } = await apiClient.request({
        method: "POST",
        url: `/api/v2/user/login`,
        withCredentials: true,
        data: body,
        headers: {}
    });
    if (!data.status) {
        throw new Error(data.error);
    }
}

// Try to get a token in case we have a cookie set.
export async function autoSignIn() {
    try {
        const [key, secret] = await getToken();
        setApiCredentials(key, secret);
    } catch (err) {
        // TODO: handle auth error
        // eslint-disable-next-line no-console
        console.log('authentication error', err);
    }
}

export const useSignIn = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (username, password) {
        yield putFeedback({busy: true});
        try {
            yield call(signIn, username, password);
            const [key, secret] = yield call(getToken);
            setApiCredentials(key, secret);
        } finally {
            yield putFeedback({busy: false});
        }
        yield call(loadUserProfile);
    }, []));
};
